import { Icon } from '@y42/core/icon';
import { gitlabIcon } from '@y42/icons';

export enum GitProvider {
  Gitlab = 'gitlab',
}

export const GitProviderToLabel: Record<GitProvider, string> = {
  [GitProvider.Gitlab]: 'GitLab',
};

export const GitProviderToLogo: Record<GitProvider, Icon> = {
  [GitProvider.Gitlab]: gitlabIcon,
};
